import React from 'react';
import { ToolbarProps } from 'react-big-calendar';
import { IconButton, Typography, Box } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import moment from 'moment';

interface CustomToolbarProps extends ToolbarProps {
  // Add any custom props if needed
}

const CustomCalendarToolbar: React.FC<CustomToolbarProps> = ({ onNavigate, label }) => {
  const goToBack = () => {
    onNavigate('PREV');
  };

  const goToNext = () => {
    onNavigate('NEXT');
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
      <IconButton onClick={goToBack}>
        <ArrowBackIosIcon />
      </IconButton>
      <Typography variant="h6" sx={{ mx: 2 }}>
        {label}
      </Typography>
      <IconButton onClick={goToNext}>
        <ArrowForwardIosIcon />
      </IconButton>
    </Box>
  );
};

export default CustomCalendarToolbar;
